import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useContext } from 'react';
import dynamic from 'next/dynamic';
import { Context } from '../../../global-state-context';
import { isRenderForm } from '../../../utils/formUtility';
import { FORM_SUBMISSION_THANKYOU } from '../../../constants/labels/en';
import Slider from '../Slider';
import SliderCard from '../../molecules/SliderCard';
import PencilBannerAdapter from '../PencilBanner/PencilBannerAdapter';
import FiveCardNvaAdapter from '../FiveCardNva/FiveCardNvaAdapter';
import SecondaryPageHeroAdapter from '../SecondaryPageHero/SecondaryPageHeroAdapter';
import HeaderMultiLocationAdapter from '../HeaderMultiLocation/HeaderMultiLocationAdapter';
import HeroCarouselAdapter from '../HeroCarousel/HeroCarouselAdapter';
import PromoBannerAdapter from '../PromoBanner/PromoBannerAdapter';
import SpacerAdapter from '../../atoms/Spacer/SpacerAdapter';
import FiveCardAdapter from '../FiveCard/FiveCardAdapter';
import LocationInfoAdapter from '../LocationInfo/LocationInfoAdapter';
import AccordionAdapter from '../../molecules/Accordion/AccordionAdapter';
import ThreeTileAdapter from '../ThreeTile/ThreeTileAdapter';
import ReviewsAdapter from '../Reviews/ReviewsAdapter';
import DocumentsAndFormsAdapter from '../DocumentsAndForms/DocumentsAndFormsAdapter';
import ThreeColumnTextAdapter from '../ThreeColumnText/ThreeColumnTextAdapter';
import MailchimpAdapter from '../../atoms/Mailchimp/MailchimpAdapter';
import FormKeepAdapter from '../../atoms/FormKeep/FormKeepAdapter';
import ContactUsFormAdapter from '../ContactUsForm/ContactUsFormAdapter';
import TableAdapter from '../../atoms/Table/TableAdapter';
import TableEditorAdapter from '../../atoms/TableEditor/TableEditorAdapter';
import GoogleMapsHappyHealthyPetsV2Adapter from '../GoogleMapsHappyHealthyPetsV2/GoogleMapsHappyHealthyPetsV2Adapter';
import BlogArticleListAdapter from '../BlogArticleList/BlogArticleListAdapter';
import ServicesBladeAdapter from '../ServicesBlade/ServicesBladeAdapter';
import StaffBladeAdapter from '../StaffBlade/StaffBladeAdapter';
import SearchBladeAdapter from '../SearchBlade/SearchBladeAdapter';
import FiftyFiftyAdapter from '../FiftyFifty/FiftyFiftyAdapter';
import MiniGalleryAdapter from '../MiniGallery/MiniGalleryAdapter';
import ImageSliderAdapter from '../ImageSlider/ImageSliderAdapter';
import _RichTextBlob from '../RichTextBlob';
export var HeroCarouselComponent = function HeroCarouselComponent(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  var _useContext = useContext(Context),
    blurredPageHeroBgImg = _useContext.blurredPageHeroBgImg;
  return entry.useSwiperCarousel ? __jsx(Slider, {
    isHero: true,
    heroCarouselData: entry
  }, entry.cardsCollection.items.map(function (item, index) {
    return __jsx(Slider.Slide, {
      key: index,
      index: index
    }, __jsx(SliderCard, {
      heroData: item,
      isHero: true,
      mobileHeroVariation: entry.mobileHeroVariation,
      options: entry.carouselOptions,
      blurredPageHeroBgImg: blurredPageHeroBgImg
    }));
  })) : __jsx(HeroCarouselAdapter, {
    entry: entry,
    data: _objectSpread(_objectSpread({}, data), {}, {
      blurredPageHeroBgImg: blurredPageHeroBgImg,
      shouldPreloadImage: data.shouldPreloadImage
    })
  });
};
var componentsMap = {
  PencilBanner: function PencilBanner(_ref2) {
    var entry = _ref2.entry;
    return __jsx(PencilBannerAdapter, {
      entry: entry
    });
  },
  Story: function Story(_ref3) {
    var entry = _ref3.entry,
      data = _ref3.data;
    return __jsx(FiveCardNvaAdapter, {
      entry: entry,
      data: data
    });
  },
  // scrollBarWidth
  SecondaryHero: function SecondaryHero(_ref4) {
    var entry = _ref4.entry,
      data = _ref4.data;
    return __jsx(SecondaryPageHeroAdapter, {
      entry: entry,
      data: data
    });
  },
  // shouldPreloadImage, scrollbarWidth
  LocatorMap: function LocatorMap(_ref5) {
    var entry = _ref5.entry,
      data = _ref5.data;
    data.isBlade = true;
    return __jsx(HeaderMultiLocationAdapter, {
      entry: entry,
      data: data
    });
  },
  // themeName
  HeroCarousel: function HeroCarousel(_ref6) {
    var entry = _ref6.entry,
      data = _ref6.data;
    return __jsx(HeroCarouselAdapter, {
      entry: entry,
      data: data
    });
  },
  // scrollbarWidth, shouldPreloadImage
  PromoBanner: function PromoBanner(_ref7) {
    var entry = _ref7.entry;
    return __jsx(PromoBannerAdapter, {
      entry: entry
    });
  },
  Spacer: function Spacer(_ref8) {
    var entry = _ref8.entry;
    return __jsx(SpacerAdapter, {
      entry: entry
    });
  },
  RichTextBlob: function RichTextBlob(_ref9) {
    var entry = _ref9.entry,
      data = _ref9.data;
    return __jsx(_RichTextBlob, {
      entry: entry,
      data: data
    });
  },
  CategoryCardsBlade: function CategoryCardsBlade(_ref10) {
    var entry = _ref10.entry,
      data = _ref10.data;
    return __jsx(FiveCardAdapter, {
      entry: entry,
      data: data
    });
  },
  LocationInformationBlade: function LocationInformationBlade(_ref11) {
    var entry = _ref11.entry,
      data = _ref11.data;
    return __jsx(LocationInfoAdapter, {
      entry: entry,
      data: data
    });
  },
  // yextContactInfo
  AccordionBlade: function AccordionBlade(_ref12) {
    var entry = _ref12.entry;
    return __jsx(AccordionAdapter, {
      entry: entry
    });
  },
  TileCategoryCardsBlade: function TileCategoryCardsBlade(_ref13) {
    var entry = _ref13.entry;
    return __jsx(ThreeTileAdapter, {
      entry: entry
    });
  },
  ReviewsBlade: function ReviewsBlade(_ref14) {
    var entry = _ref14.entry,
      data = _ref14.data;
    return __jsx(ReviewsAdapter, {
      entry: entry,
      data: data
    });
  },
  Panel: function Panel(_ref15) {
    var entry = _ref15.entry;
    return __jsx(FiftyFiftyAdapter, {
      entry: entry
    });
  },
  Gallery: function Gallery(_ref16) {
    var entry = _ref16.entry;
    return __jsx(MiniGalleryAdapter, {
      entry: entry
    });
  },
  ImageSlider: function ImageSlider(_ref17) {
    var entry = _ref17.entry;
    return __jsx(ImageSliderAdapter, {
      entry: entry
    });
  },
  DocumentsAndForms: function DocumentsAndForms(_ref18) {
    var entry = _ref18.entry;
    return __jsx(DocumentsAndFormsAdapter, {
      entry: entry
    });
  },
  ColumnTextBlocks: function ColumnTextBlocks(_ref19) {
    var entry = _ref19.entry;
    return __jsx(ThreeColumnTextAdapter, {
      entry: entry
    });
  },
  Mailchimp: function Mailchimp(_ref20) {
    var entry = _ref20.entry;
    return __jsx(MailchimpAdapter, {
      entry: entry
    });
  },
  FormkeepForm: function FormkeepForm(_ref21) {
    var entry = _ref21.entry,
      data = _ref21.data;
    var formData = {
      submitUrl: entry.submitUrl,
      successfulSubmissionMessage: entry.successfulMessage || FORM_SUBMISSION_THANKYOU,
      reCaptchaKey: data.siteData.reCaptchaKey,
      fontColor: entry.fontColor,
      formkeepTest: entry.formKeepCode
    };
    if (entry.showNewForm == true && entry.formKeepCode) {
      return __jsx(FormKeepAdapter, {
        entry: formData,
        data: data
      });
    } else if (isRenderForm(formData)) {
      return __jsx(ContactUsFormAdapter, {
        entry: formData
      });
    }
  },
  Table: function Table(_ref22) {
    var entry = _ref22.entry;
    if (entry !== null && entry !== void 0 && entry.tableEditor) {
      return __jsx(TableEditorAdapter, {
        entry: entry
      });
    } else if (entry !== null && entry !== void 0 && entry.tableContent && (!(entry !== null && entry !== void 0 && entry.tableEditor) || (entry === null || entry === void 0 ? void 0 : entry.tableEditor.length) <= 0)) {
      return __jsx(TableAdapter, {
        entry: entry
      });
    }
  },
  LocationsHappyHealthyPets: function LocationsHappyHealthyPets(_ref23) {
    var entry = _ref23.entry;
    if (entry.useNewMap) {
      return __jsx(GoogleMapsHappyHealthyPetsV2Adapter, {
        entry: entry
      });
    }
    var GoogleMapsHappyHealthyPetsAdapter = dynamic(function () {
      return import('../GoogleMapsHappyHealthyPets/GoogleMapsHappyHealthyPetsAdapter');
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [require.resolveWeak('../GoogleMapsHappyHealthyPets/GoogleMapsHappyHealthyPetsAdapter')];
        }
      }
    });
    return __jsx(GoogleMapsHappyHealthyPetsAdapter, {
      entry: entry
    });
  },
  BlogBlade: function BlogBlade(_ref24) {
    var entry = _ref24.entry,
      data = _ref24.data;
    return __jsx(BlogArticleListAdapter, {
      entry: entry,
      data: data
    });
  },
  ServicesBladeBlockListing: function ServicesBladeBlockListing(_ref25) {
    var entry = _ref25.entry,
      data = _ref25.data;
    return __jsx(ServicesBladeAdapter, {
      entry: entry,
      data: data
    });
  },
  StaffBlade: function StaffBlade(_ref26) {
    var entry = _ref26.entry,
      data = _ref26.data;
    return __jsx(StaffBladeAdapter, {
      entry: entry,
      data: data
    });
  },
  SearchBlade: function SearchBlade(_ref27) {
    var data = _ref27.data;
    return __jsx(SearchBladeAdapter, {
      data: data
    });
  }
};
export default componentsMap;